import moment from "moment";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import H1 from "../H1";
import H2 from "../H2";
import { msToString, msToStringFormatted } from "../helpers/time";
import { timersApi } from "../../imports";

export default function TimeToTimeOfDay({
	cue,
	cloud,
	baseTheme,
	baseThemeId,
	cuePreview = false,
}) {
	const [t, setT] = useState();

	useEffect(() => {
		let intervalId;
		clearInterval(intervalId);

		intervalId = 
			setInterval(() => {
				let now = moment().format("x");
				let end = moment(cue.endTime).format("x");
				let diff = end - now;
				if (diff < 100 && cue.onEnd === "hold") {
					return setT(0);
				}
				setT(diff);
			}, 100)

		return () => {
			clearInterval(intervalId);
		};
	}, [cue.endTime, cue.onEnd]);

	if (cuePreview) {
		return <>{msToString(t)}</>;
	}

	return (
		<>
			{cue.pre && (
				<H2
					cue={cue}
					text={cue.pre}
					baseTheme={baseTheme}
					baseThemeId={baseThemeId}
				/>
			)}
			<H1
				cue={cue}
				text={msToStringFormatted(t, cue.trim, cue.format || "HH:mm:ss")}
				baseTheme={baseTheme}
				baseThemeId={baseThemeId}
				tabular={true}
			/>
		</>
	);
}
